import UpcomingSessionMessage from './UpcomingSessionMessage';

export default UpcomingSessionMessage;
